import { render } from "./CreateRelationModal.vue?vue&type=template&id=74c02f7e&ts=true"
import script from "./CreateRelationModal.vue?vue&type=script&lang=ts"
export * from "./CreateRelationModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__